<template>
  <el-container>
    <el-header class="header-container">
      <header-bar></header-bar>
    </el-header>
    <el-container>
      <el-aside class="left-container">
        <el-scrollbar class="left-scrollbar">
          <nav-menu :menu="menu"></nav-menu>
        </el-scrollbar>
      </el-aside>
      <el-main class="main-container"><router-view /></el-main>
    </el-container>
  </el-container>
</template>
<script>
import HeaderBar from "./headerbar/index";
import NavMenu from "./navmenu/index";
import store from "@/store";

export default {
  components: { HeaderBar, NavMenu },
  data() {
    return {
      menu: [],
    };
  },
  created: function () {
    this.menu = store.getters.menu;
    // console.log(this.menu);
  },
  watch:{
    //  a(){
    //     this.menu = store.getters.menu;
    // }
  },
};
</script>
<style lang="scss">
.el-container {
  width: 100%;
  height: 100%;
  .header-container {
    height: 50px !important;
    background-color: #409eff;
    padding: 0px;
  }
  .left-container {
    width: 200px !important;
    height: 100%;
    background-color: #304156;
    .left-scrollbar {
      height: calc(100vh - 50px);
      .el-scrollbar__wrap {
        overflow-x: hidden !important;
      }
      .el-menu-vertical-demo{
        padding: 0px 0px 15px 0px !important;
        
      }
      //  .el-menu-item {
      //     height: 40px;
      //     line-height: 40px;
      //   }
      //   .el-submenu{
      //     height: 40px;
      //     line-height: 40px;
      //   }
      .el-menu{
        padding: 0px 0px 0px 0px;
      }
      
    }
  }
  .main-container {
    background-color: #ffffff;
    padding: 5px;
    position: relative;
  }
 
}
</style>


// WEBPACK FOOTER //
// src/components/layout/index.vue